import axios, { AxiosRequestConfig, CancelTokenSource } from 'axios'

import { deepDebounce } from '../../../utilities/deepDebounce'
import { getOrganisationDuplicate } from '../api'

let cancelTokenSource: CancelTokenSource | null = null

export const getOrganisationDuplicateData = deepDebounce(
  async (fieldName: string, value?: string, id?: string): Promise<any[]> => {
    if (cancelTokenSource) {
      cancelTokenSource.cancel('Operation cancelled due to new request.')
    }

    cancelTokenSource = axios.CancelToken.source()
    const config: AxiosRequestConfig = {
      cancelToken: cancelTokenSource.token,
    }

    try {
      const response = await getOrganisationDuplicate(
        {
          [fieldName]: value,
          assessor_id: id,
        },
        config
      )

      const data = response?.data?.map((item: any) => ({
        ...item,
        first_name: item?.default_assessor?.first_name,
        mobile: item?.default_assessor?.mobile,
        mobile_2: item?.default_assessor?.mobile_2,
        email: item?.default_assessor?.email,
        email_2: item?.default_assessor?.email_2,
        last_name: item?.default_assessor?.last_name,
      }))

      return data
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Request cancelled', error.message)
      } else {
        console.error('An error occurred:', error)
      }
      return [] // return an empty array or handle the error as needed
    }
  },
  1000
)

export const getFileName = (url = '--'): string => {
  const parts = url.split('/')
  return parts[parts.length - 1]
}
